import Stream from "./Stream";
export default {
    name: "participants",
    components: {
        Stream: Stream,
    },
    data: function () {
        return {
            layoutModified: false,
            expandedStream: "",
        };
    },
    watch: {
        peers: function (peers) {
            var _this = this;
            peers.forEach(function (peer) {
                if (peer.screenSource) {
                    _this.expandedStream = peer.identifier;
                }
            });
            if (this.expandedStream || this.layoutModified)
                return;
            this.expandedStream = peers[0].identifier;
        },
    },
    computed: {
        peers: function () {
            return this.$store.getters.peers.filter(function (peer) { return !peer.isLocal; });
        },
        isAnyStreamExpanded: function () {
            return !!this.expandedStream;
        },
    },
    methods: {
        expandStream: function (id) {
            this.layoutModified = true;
            if (this.expandedStream === id && this.peers.length > 1) {
                this.expandedStream = "";
                return;
            }
            this.expandedStream = id;
        },
        videoDisplayClass: function (id) {
            if (this.expandedStream === id)
                return "expanded-video";
            return "minature-video";
        },
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Participants.vue
// module id = 331
// module chunks = 1